import { ContractViewModel, ServiceKind } from '@ail/contracts-api'
import 'nouislider/distribute/nouislider.css'
import React, { useMemo, useState } from 'react'
import './FuelCardDetails.scss'
import { useTranslation } from 'react-i18next'

export function FuelCardDetails(props: { contract?: ContractViewModel }) {
  const [position, setPosition] = useState(0)

  const { t } = useTranslation('common')

  const activeFuelCards = useMemo(() => {
    return (
      props.contract?.services?.filter((s) => {
        return s.kind === ServiceKind.Fuel && s.name !== 'Treibstoff' && !!s.TpsReferenceCode
      }) ?? []
    )
  }, [props.contract])

  const rawDate = activeFuelCards[position]?.FuelCardExpirationDate

  const changeCard = (i: number) => {
    setPosition(i)
  }

  const dumbIcon = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = '/makesLogos/dummy.svg'
  }

  const moveForward = () => {
    const way = activeFuelCards.length
    if (position < way - 1) {
      setPosition(position + 1)
    } else {
      setPosition(0)
    }
  }

  const moveBack = () => {
    const way = activeFuelCards.length
    if (position === 0) {
      setPosition(way - 1)
    } else {
      setPosition(position - 1)
    }
  }

  return (
    !!activeFuelCards.length && (
      <div className="detailContentArea">
        <div className="detailTitle">
          <i className="icon-fuelcard" /> <span>{t('FUEL')}</span>
        </div>
        <div className="fuelCardlist">
          {activeFuelCards.length > 1 && (
            <div className="leftArrow">
              <i onClick={moveBack} className="icon-left"></i>
            </div>
          )}
          <div className="fuelCard">
            <div className="FuelCardInfo">
              <div className="fuelArea">
                <div className="fuelDate">
                  {rawDate
                    ? (
                        ('0' + (new Date(rawDate).getMonth() + 1).toString()).slice(-2) +
                        '/' +
                        new Date(rawDate).getFullYear().toString().slice(-2)
                      ).toString()
                    : '--/--'}
                </div>
                <img
                  src={
                    '/' +
                    (activeFuelCards[position]?.name?.includes(' ')
                      ? activeFuelCards[position]?.name
                          ?.substr(0, activeFuelCards[position]?.name?.indexOf(' '))
                          .toLowerCase()
                      : activeFuelCards[position]?.name?.toLowerCase()) +
                    '.svg'
                  }
                  onError={(e) => dumbIcon(e)}
                />
                <div className="fuelName">{activeFuelCards[position]?.name}</div>
                <img
                  src={`/${
                    activeFuelCards[position]?.name?.toLowerCase().includes('international')
                      ? 'international'
                      : 'national'
                  }.svg`}
                  className="locImg"
                />
                <div className="fuelBrand">{activeFuelCards[position]?.TpsReferenceCode || '-'}</div>
                {activeFuelCards.length > 1 && (
                  <div className="circles">
                    {activeFuelCards.map((c, i) => (
                      <div
                        onClick={() => changeCard(i)}
                        key={i}
                        className="circle"
                        style={{
                          backgroundColor: `${i === position ? '#B82785' : 'white'}`,
                        }}
                      ></div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          {activeFuelCards.length > 1 && (
            <div className="rightArrow">
              <i onClick={() => moveForward()} className="icon-right"></i>
            </div>
          )}
        </div>
        <div className="fuelCardlist"></div>
      </div>
    )
  )
}
